/**
 * Constantes da página de Integrações
 */

export const INTEGRATION_PROVIDERS = [
    {
        id: "openai",
        name: "OpenAI",
        icon: "mdi-robot-outline",
        color: "#10A37F",
        description: "IA generativa para assistentes inteligentes e automações de texto.",
        configFields: [
            { key: "apiKey", label: "API Key", type: "password", placeholder: "sk-...", required: true },
            { key: "organizationId", label: "Organization ID", type: "text", placeholder: "org-... (Opcional)", required: false },
            { key: "defaultModel", label: "Modelo Padrão", type: "select", options: ["gpt-4o", "gpt-4o-mini", "gpt-4-turbo", "gpt-3.5-turbo"], required: true },
            { key: "systemPrompt", label: "Prompt do Sistema", type: "textarea", placeholder: "Defina a personalidade e instruções do assistente...", required: false }
        ],
        testPlaceholder: "Digite uma mensagem para testar a IA...",
        testEndpoint: "chat"
    },
    {
        id: "gemini",
        name: "Google Gemini",
        icon: "mdi-google",
        color: "#4285F4",
        description: "IA do Google para geração de conteúdo e análise de dados.",
        configFields: [
            { key: "apiKey", label: "API Key", type: "password", placeholder: "AIza...", required: true },
            { key: "defaultModel", label: "Modelo Padrão", type: "select", options: ["gemini-2.0-flash", "gemini-1.5-pro", "gemini-1.5-flash", "gemini-1.0-pro"], required: true },
            { key: "systemPrompt", label: "Prompt do Sistema", type: "textarea", placeholder: "Defina a personalidade e instruções do assistente...", required: false }
        ],
        testPlaceholder: "Digite uma mensagem para testar o Gemini...",
        testEndpoint: "chat"
    },
    {
        id: "evolution",
        name: "Evolution API",
        icon: "mdi-whatsapp",
        color: "#25D366",
        description: "API não oficial do WhatsApp para envio de mensagens e automações.",
        configFields: [
            { key: "apiUrl", label: "URL da API", type: "text", placeholder: "https://sua-api.com", required: true },
            { key: "apiKey", label: "Global API Key", type: "password", placeholder: "Sua chave global...", required: true },
            { key: "instanceName", label: "Nome da Instância", type: "text", placeholder: "minha-instancia", required: true },
            { key: "webhookUrl", label: "Webhook URL", type: "text", placeholder: "https://... (Opcional)", required: false }
        ],
        testPlaceholder: "Digite o número do WhatsApp (ex: 5511999887766)...",
        testEndpoint: "connection"
    }
];
